import React, { Component } from "react";
import Rating from 'react-rating';
import ReactSVG from 'react-svg';

class communityItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      storyData:{
        leftImg:'',
        rightImg:'',
        titleText:'',
        isShowfullTimeMon:true,
        typeImg1:'',
        typeImgText1:'',
        typeImg2:'',
        typeImgText2:'',
        contenText:''

      },
    };
  }
  componentDidMount(){
    try {
      this.setState({
        storyData: this.props.data,
      })
    } catch (error) {
      this.setState({
        storyData: {},
      })
    }
 
  }



  render() {
    return (
        <div className="community-item">
            <img src={this.state.storyData.leftImg} className="community-item-left-img"/>
            <img src={this.state.storyData.rightImg} className="community-item-right-img"/>

            <div className="community-item-title">
                <div className="h3">{this.state.storyData.titleText}</div>
                <div className="paragraph1">{this.state.storyData.isShowfullTimeMon ? "Full time mom": null }</div>
            </div>

            <div className="community-item-conten">
                <div className="community-item-conten-icon-tile">
                    <div>
                        <img src={this.state.storyData.typeImg1}></img>
                        <span className="paragraph1 charcoal">{this.state.storyData.typeImgText1} </span>
                    </div>
                    <div>
                        <img src={this.state.storyData.typeImg2}></img>
                        <span className="paragraph1 charcoal">{this.state.storyData.typeImgText2}</span>
                    </div>
                </div>
                <div className="paragraph1 charcoal">{this.state.storyData.contenText}</div>
            </div>
        </div>
    );
  }
}

export default communityItem;



// WEBPACK FOOTER //
// ./src/views/home/communityItem.js